import { CardInfo } from "./card-info.model";

export class CardText{
    /*
    * 
    */
   constructor(
    public id?: number,
    public textDetail?: string,
    public locale?: string,
    public photo?: string,
    public cardInfo?: CardInfo
   ){}
}